import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface LocksState {
  selectedLockId: number | null;
}

const initialState: LocksState = {
  selectedLockId: null,
};

const locksSlice = createSlice({
  name: "locks",
  initialState,
  reducers: {
    setSelectedLock: (state, action: PayloadAction<number>) => {
      state.selectedLockId = action.payload;
    },
    clearSelectedLock: (state) => {
      state.selectedLockId = null;
    },
  },
});

export const { setSelectedLock, clearSelectedLock } = locksSlice.actions;
export default locksSlice.reducer;
